import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'particularOrderStatus'
})
export class ParticularOrderStatusPipe implements PipeTransform {

  status: string = '';
  transform(value: number): unknown {
    switch (value) {
      case 0: {
        this.status = 'Nuevo';
        break;
      }
      case 1: {
        this.status = 'Confirmado';
        break;
      }
      case 2: {
        this.status = 'Asignado';
        break;
      }
      case 3: {
        this.status = 'Aceptado';
        break;
      }
      case 4: {
        this.status = 'Rechazado';
        break;
      }
       case 5: {
        this.status = 'En curso';
        break;
      }
      case 6: {
        this.status = 'Finalizado';
        break;
      }
      case 7: {
        this.status = 'Cancelada';
        break;
      }
    }
    return this.status;
  }

}